'use strict';

const StickySidebar = require('sticky-sidebar/dist/sticky-sidebar');
require('../thirdParty/ResizeSensor.js');

let stickySidebarInstance = null;
let userStickyOptions = {};

const STICKY_SIDEBAR_DEFAULTS = {
	stickySelector: '.lvz-sticky-sidebar',
	containerSelector: '.lvz-sticky-sidebar__container',
	innerWrapperSelector: '.lvz-sticky-sidebar__inner',
	headerSelector: '#lvz-top-banner, #lvz-header-info-container, #lvz-header-template',
	topSpacingBase: 0,
	bottomSpacingBase: 72, //Placeholder
	minWidth: 1023, //Base custom
};

/**
 * Returns the bottom edge of the visible sticky header stack.
 * The header layers move while scrolling, so their rendered position is more
 * reliable than summing their heights.
 * @param {object} config
 * @returns {number}
 */
function calculateTopSpacing(config) {
	let maxBottom = 0;

	$(config.headerSelector).each(function () {
		const rect = this.getBoundingClientRect();

		if (rect.height > 0 && rect.bottom > maxBottom) {
			maxBottom = rect.bottom;
		}
	});

	return Math.max(0, Math.ceil(maxBottom + config.topSpacingBase));
}

/**
 * Returns the PDP bottom sticky bar height in pixels.
 * @returns {number}
 */
function getPdpStickyBarHeight() {
	const cssHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--lvz-pdp-sticky-bar-height'), 10);

	if (!isNaN(cssHeight) && cssHeight > 0) {
		return cssHeight;
	}

	const $bar = $('[data-lvz-pdp-sticky-bar]');
	return $bar.length ? $bar.outerHeight() || 0 : 0;
}

/**
 * Calculate bottom spacing (base + PDP sticky bar clearance).
 * @param {object} config
 * @returns {number}
 */
function calculateBottomSpacing(config) {
	return config.bottomSpacingBase + getPdpStickyBarHeight();
}

/**
 * Init sticky sidebar element
 * @param {object} [options]
 */
function initStickySidebar(options) {
	if (options) {
		userStickyOptions = options;
	}

	const config = $.extend({}, STICKY_SIDEBAR_DEFAULTS, userStickyOptions); //Merge defaults with user options (user overrides defaults)
	const mq = matchMedia('(min-width: ' + config.minWidth + 'px)');

	destroyStickySidebar();

	if (!mq.matches || !$(config.stickySelector).length) {
		return;
	}

	stickySidebarInstance = new StickySidebar(config.stickySelector, {
		containerSelector: config.containerSelector,
		innerWrapperSelector: config.innerWrapperSelector,
		topSpacing: function () {
			return calculateTopSpacing(config);
		},
		bottomSpacing: function () {
			return calculateBottomSpacing(config);
		},
		resizeSensor: true,
	});
}

/**
 * Update sticky sidebar
 */
function updateStickySidebar() {
	if (stickySidebarInstance) {
		stickySidebarInstance.updateSticky();
	}
}

/**
 * Destroy sticky sidebar
 */
function destroyStickySidebar() {
	if (stickySidebarInstance && typeof stickySidebarInstance.destroy === 'function') {
		stickySidebarInstance.destroy();
	}

	stickySidebarInstance = null;
}

$(window).on('resize', function () {
	initStickySidebar();
});

module.exports = {
	initStickySidebar: initStickySidebar,
	updateStickySidebar: updateStickySidebar,
	destroyStickySidebar: destroyStickySidebar,
};
